import React, { Component } from "react";
import PropTypes from "prop-types";
import ExtracontentContent from "./ExtracontentContent";
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from '../WeboldalakTooltips';

class ExtracontentBase extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let cardStyle = {
      padding: 20
    };

    return (
      <div>
        <div className="animated fadeIn">
          <div className="card">
            <div className="card-header">
              {"Extra tartalom"}
              <CustomTooltip text={getTooltip('extratartalom')} id="extratartalomTT" />
              </div>
            <div className="row" style={cardStyle}>
              <div className="col-md-12">
                <ExtracontentContent {...this.props} globals={this.props.globals} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ExtracontentBase.propTypes = {
  route: PropTypes.object,
  globals: PropTypes.object
};

export default ExtracontentBase;
